import { AxiosInstances as AxiosInstance} from './BaseService'

export default {
    getData: () =>
        AxiosInstance({
            'method': 'GET',
            'url': '/codeset',
        })

}